'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var SessionContext = require('../../providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemQuantityContext = /*#__PURE__*/React__default["default"].createContext(null);
const useItemQuantity = () => {
  const context = React.useContext(ItemQuantityContext);
  if (!context) {
    throw new Error('No context provided for ItemQuantity provider');
  }
  return context;
};
const ItemQuantityProvider = _ref => {
  let {
    children,
    value: {
      currentItemDetails,
      currentItemClaim,
      computeMaxQuantity
    }
  } = _ref;
  const {
    state: {
      claimType
    },
    handleItemClaimDetailUpdate,
    handleNavigateBack
  } = index.useClaimBuilder();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const maxClaimableQuantity = computeMaxQuantity({
    currentItemDetails,
    currentItemClaim
  });
  const options = new Array(maxClaimableQuantity).fill(null).map((_, i) => ({
    value: `${i + 1}`,
    label: `${i + 1}`
  }));
  const [quantity, setQuantity] = React.useState(options.find(option => {
    if (currentItemClaim.quantity >= 0) {
      return option.value === `${currentItemClaim.quantity}`;
    }
    return false;
  }) ?? options[0]);
  const onQuantityChange = value => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_QUANTITY_SELECTED,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_QUANTITY,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_QUANTITY,
      order_number: orderNumber,
      claim_reason: claimType
    });
    setQuantity(value || options[0]);
  };
  const onSubmit = () => {
    if (!quantity) return;
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_QUANTITY_NEXT,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_QUANTITY,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_QUANTITY,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleItemClaimDetailUpdate({
      update: {
        quantity: Number.parseInt(quantity.value)
      },
      step: index.ClaimStepId.QUANTITY
    });

    // Quantity is the first step. If it's the only step, the item is getting added to the claim
    const isLastStep = (currentItemClaim === null || currentItemClaim === void 0 ? void 0 : currentItemClaim.claimSteps.length) === 1;
    if (isLastStep) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'product_added',
        properties: {
          product_id: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.itemId,
          sku: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.sku,
          name: currentItemDetails === null || currentItemDetails === void 0 ? void 0 : currentItemDetails.name,
          extra_properties: [{
            key: 'product_quantity',
            value: `${quantity.value}`
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  };
  const onBack = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ITEM_QUANTITY_BACK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_QUANTITY,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_QUANTITY,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleNavigateBack();
  };
  return /*#__PURE__*/React__default["default"].createElement(ItemQuantityContext.Provider, {
    value: {
      currentItemDetails,
      currentItemClaim,
      quantity,
      onSubmit,
      onBack,
      options,
      onQuantityChange
    }
  }, children);
};

exports.ItemQuantityContext = ItemQuantityContext;
exports.ItemQuantityProvider = ItemQuantityProvider;
exports.useItemQuantity = useItemQuantity;
